import { useEffect, useRef } from 'react';
export const useOnMount = callback => {
  const callbackRef = useRef(callback);
  callbackRef.current = callback;
  useEffect(() => {
    callbackRef.current();
  }, []);
};
//# sourceMappingURL=use-on-mount.js.map